module.exports = __webpack_public_path__ + "img/telematik.de1d8bf1.svg";